export default {
    dependencies: ['$element', 'bucketcookieservice'],
    callable(ele, bucketCookie) {
        const LIST_LAYOUT = 'listLayout';
        const listButton = ele.querySelector('[data-list-layout=list]');
        const gridButton = ele.querySelector('[data-list-layout=grid]');

        if (!hasFlexWrapSupport()) {
            bucketCookie.set(LIST_LAYOUT, 'list');
            Array.from(
                ele.querySelectorAll('[data-list-layout]')
            ).forEach(e => {
                e.remove();
            });
            return;
        }

        function handleListClick() {
            bucketCookie.set(LIST_LAYOUT, 'list');
            document.location.reload(true);
        }

        function handleGridClick() {
            bucketCookie.set(LIST_LAYOUT, 'grid');
            document.location.reload(true);
        }

        if (listButton) {
            listButton.addEventListener('click', handleListClick);
        }
        if (gridButton) {
            gridButton.addEventListener('click', handleGridClick);
        }

        function hasFlexWrapSupport() {
            const testEle = document.createElement('div');
            const flexTweenTest = '-ms-flex-align: end;'; // IE10
            // Smoke out browsers on old spec, not supporting wrapping. http://caniuse.com/#feat=flexbox
            const flexWrapTest = '-webkit-flex-wrap:wrap; flex-wrap:wrap;';
            testEle.setAttribute('style', flexTweenTest + flexWrapTest);
            return (
                testEle.style.flexWrap ||
                testEle.style.webkitFlexWrap ||
                testEle.style.msFlexAlign
            );
        }
    },
};



// WEBPACK FOOTER //
// ./controllers/listLayoutButtons.js